import * as React from 'react';

import { SVGComponentProps } from './svg.types';

const GlobeSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherSvgProps
}: SVGComponentProps) => (
  <span className={`inline-block ${wrapperClass || ''}`}>
    <svg
      width={size}
      height={size}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...otherSvgProps}
    >
      <path
        d="M5.99998 0C2.66518 0 0 2.70374 0 5.99998C0 9.32865 2.70379 12.0001 5.99859 12C9.30655 12 12 9.32033 12 5.99998C12 2.70758 9.33697 0 5.99998 0ZM4.66343 6.6067L4.22143 8.52224C4.11066 9.00243 3.44324 9.07782 3.23614 8.61925L2.24174 6.41301L2.90575 4.46405C2.96279 4.29669 2.88665 4.11303 2.72793 4.0351L1.39495 3.38059C1.91287 2.46934 2.68293 1.73781 3.61522 1.26874V2.14194C3.61522 2.308 3.73142 2.45144 3.89389 2.48587L5.69402 2.86745C5.93871 2.9192 6.13012 3.10178 6.19355 3.34384L6.36368 3.99334C6.41583 4.19281 6.37033 4.40811 6.24201 4.56924L4.73098 6.46673C4.69831 6.50775 4.67522 6.55558 4.66343 6.6067ZM5.61049 11.2828L5.81222 10.857C5.84974 10.7777 5.89141 10.7403 5.96522 10.6956C6.0431 10.649 6.16127 10.5947 6.35557 10.4972C6.52936 10.4102 6.71587 10.4654 6.81754 10.599C6.81757 10.599 6.81761 10.599 6.81764 10.5991L7.23815 11.1512C6.70748 11.2781 6.15687 11.3226 5.61049 11.2828ZM9.4137 10.0499L8.95304 9.75109L8.74644 7.83627C8.7261 7.64788 8.77499 7.45851 8.88404 7.30317L9.92162 5.82638C9.9632 5.7672 9.98553 5.6966 9.98553 5.62428V4.26784L10.6589 3.4776C11.0775 4.24866 11.2969 5.11175 11.2969 5.99998C11.2968 7.61676 10.5734 9.07011 9.4137 10.0499Z"
        fill={fill}
      />
    </svg>
  </span>
);

export default GlobeSVG;
